import {ReactNode} from 'react';
import {InfoBox} from '@chekinapp/ui';
import {useFormContext} from 'react-hook-form';
import {CONTACTS_FORM_ID} from './constants';
import {FormTypes} from './types';

type Props = {
  note: ReactNode;
  noteIcon: ReactNode;
  onSubmit: (data: FormTypes) => Promise<void>;
  children: ReactNode;
};

const ContactsForm = ({note, noteIcon, onSubmit, children}: Props) => {
  const {handleSubmit} = useFormContext();

  return (
    <form
      id={CONTACTS_FORM_ID}
      onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col gap-4"
    >
      {children}

      <InfoBox icon={noteIcon}>{note}</InfoBox>
    </form>
  );
};

export {ContactsForm};
